import { createSelector } from 'reselect';
export {
  default as cartSelector,
  getCartStatus,
  getCartItemsStatus,
} from './cart';
export { default as paymentSelector } from './payment';
export { default as statusSelector } from './status';
export { default as authSelector } from './auth';
export { default as orderSelector } from './order';
export { default as uiselector } from './ui';
export { default as profileSelector } from './profile';
export { default as errorSelector } from './error';

// ---
// UI.
// ---
export const getFilter = state => state.data.ui.showFilter;
export const getNav = state => state.data.ui.showNav;
export const getCart = state => state.data.ui.showCart;
export const getOrderSummary = state => state.data.ui.showOrderSummary;
export const getPrices = state => state.data.ui.showPrices;

// ---
// Cart.
// ---
export const getCartID = state => state.data.cart.id;
export const getCartItems = state => state.data.cart.items;
export const getCartTax = state => state.data.cart.summary.tax;
export const getCartTotal = state => state.data.cart.summary.total;
export const getCartSubTotal = state => state.data.cart.summary.subtotal;
export const getCartItemsCount = state => state.data.cart.summary.items_count;
export const getCartShipping = state => state.data.cart.summary.shipping;
export const getCartSummary = createSelector(
  [
    getCartTax,
    getCartTotal,
    getCartSubTotal,
    getCartItemsCount,
    getCartShipping,
  ],
  (tax, total, subtotal, itemsCount, shipping) => ({
    tax,
    total,
    subtotal,
    itemsCount,
    shipping,
  })
);

// ---
// Auth.
// ---
export const getVerifyStatus = state => state.status.verify;
export const getAuthStatus = state => state.status.auth;
export const getUserID = state => state.data.user.id;
export const getAuthToken = state => state.data.user.token;

// ---
// Profile.
// ---
export const getProfile = state => state.data.profile;

// ---
// Order.
// ---
export const getOrderForm = state => state.data.order.orderForm;
export const getDeliveryAddress = state =>
  state.data.order.orderForm.customer.customer_delivery_address;
export const getInvoiceAddress = state =>
  state.data.order.orderForm.customer.customer_invoice_address;
export const getPayment = state => state.data.payment;
export const getCreateOrderStatus = state => state.status.createOrder;
export const getPayOrderStatus = state => state.status.payOrder;
export const getActiveOrder = state => state.data.order.activeOrder;

// ---
// UI: Selector.
// ---
export const uiSelector = createSelector(
  [getNav, getFilter, getCart, getOrderSummary, getPrices],
  (showNav, showFilter, showCart, showOrderSummary, showPrices) => ({
    showNav,
    showFilter,
    showCart,
    showOrderSummary,
    showPrices,
  })
);

// ---
// DeliverySummary: Selector.
// ---
export const deliverySelector = createSelector(
  [getProfile, getDeliveryAddress, getInvoiceAddress],
  (profile, deliveryAddress, invoiceAddress) => ({
    profile,
    deliveryAddress,
    invoiceAddress,
  })
);

export const orderStatusSelector = createSelector(
  [getPayment, getCreateOrderStatus, getPayOrderStatus, getActiveOrder],
  (payment, createOrderStatus, payOrderStatus, activeOrder) => ({
    payment,
    createOrderStatus,
    payOrderStatus,
    activeOrder,
  })
);



// WEBPACK FOOTER //
// ../shop_main/selector/index.js